/* eslint-disable max-len */
import React,{useState,useContext} from 'react'
import OrderLevelProgress from '../../Pages/MyOrders/ViewOrder/Components/ProgressBar/OrderLevelProgress'
import { Addtowishlist, WishlistExist } from '../../redux/helper/AddWishlist'
import { PriceHandler } from '../../redux/helper/CamelCase'
import AddressHover from '../AddressChangeModal/AddressHover'
import HeaderContext from '../Context/HeaderContext'
import OfferToolTip from '../OfferToolTip'
import ItemPriceTooltip from '../ItemPriceTooltip';
import WishlistHandler from '../WishlistHandler'
import ItemDetailsSection from './ItemsCards/ItemDetailsSection'
import ItemImageSection from './ItemsCards/ItemImageSection'

export default function OrderSummary({prod,OrderData,wishProducts,GetCartItems,handleUpdateAddress,addressDropdown,Calculation,
    GroupCategory,setGroupCategoryValue,groupIdx}) {
    const DapApplied = Number(OrderData?.status) <3

    const [ModalOpen, setModalOpen] = useState('');
    const [itemPricehoverId, setItemPricehoverId] = useState('');
    const [proposedPricehoverId, setProposedPricehoverId] = useState('');
    const [revisedPricehoverId, setRevisedPricehoverId] = useState('');
    const [subTotalhoverId, setSubTotalPricehoverId] = useState('');
    const [netAmounthoverId, setNetAmounthoverId] = useState('');
    const [totalPricehoverId, setTotalPricehoverId] = useState('');
    const [grossAmounthoverId, setGrossAmounthoverId] = useState('');



    const [loader, setloader] = useState(false);
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
        setisPopup
    } = useContext(HeaderContext);
     
    const handleErrorMessage = (message,key)=>{
        SetErrorMessage(message ||'Something went wrong');
        setcolorValue(true);
        GetCartItems();
        setModalOpen('');
        setTimeout(() => {
            SetErrorMessage('');
            setcolorValue(false);
            setloading(false);
            setremoveLoader(false)
            setremovePopup('')

        }, 2000);
    }
    const handleSuccessMessage = (message, key)=>{
        SetSuccessMessage(message);
        setModalOpen('');
        GetCartItems();
        setTimeout(() => {
            SetSuccessMessage('');
            setcolorValue(false);
            // setloading(false);
            // setremoveLoader(false)
            // setremovePopup('')
            if(key==='diff'){
                setModalOpen('key');
            }
        },2000)
    }
    const handleAddToWishList = (selected,related)=>{
        setloader(true)
        Addtowishlist(prod,selected).then((res)=>{
            if(res.data.success_status){
                handleSuccessMessage(res.data.message,'wish')
            }else{
                handleErrorMessage(res.message.response.data.message,'wish')
            }
            setloader(false)
        })
    }
    const [hoverId, sethoverId] = useState('')
    return (
        <div><div className="rounded-lg bg-[#FFFFFF] shadow-s7 px-4 pb-2.5 mb-5 pt-4 m-1 relative">
            <ItemImageSection prod={prod}/>
            <ItemDetailsSection groupIdx={groupIdx} 
                prod={prod} 
                OrderData={OrderData} 
                GroupCategory={GroupCategory}
                setGroupCategoryValue={setGroupCategoryValue}
                handleUpdateAddress={handleUpdateAddress} 
                addressDropdown={addressDropdown}/>
            
            {Number(OrderData?.order?.status) <=2 ? 
                <div className="w-full border-[#CBCBCB] py-3 border-t">
                    <div className="w-full flex flex-wrap items-center -mx-2">
                        <div className="lg:w-1/4 w-1/2 px-2">
                            <div className="w-full">
                                <p className="text-xs3 font-semibold text-[#808285]">List Price</p>
                                <p className="md:text-xs10 sm:text-lg text-base font-semibold text-[#15090E]">{PriceHandler(prod?.LIST_PRICE)}</p>
                            </div>
                        </div>
                        <div className="lg:w-1/4 w-1/2 px-2">
                            <div className="w-full">
                                <p className="text-xs3 font-semibold text-[#808285] text-start mr-[17px]">Quantity</p>
                                <p className="md:text-xs10 sm:text-lg text-base font-semibold text-[#15090E]">{prod?.quantity}{prod?.PRIMARY_UOM_CODE}</p>
                            </div>
                        </div>
                        <div className="lg:w-1/4 w-1/2 px-2">
                            <div className="w-full">
                                <p className="text-xs3 font-semibold text-[#808285] text-start mr-[17px]">Discount</p>
                                <p className="md:text-xs10 sm:text-lg text-base font-semibold text-[#15090E]">{PriceHandler(prod?.discount_applied)}
                                    <span className="ml-1 relative">
                                        <button  onMouseEnter={()=>{
                                            setTimeout(() => {
                                                sethoverId(prod.INVENTORY_ITEM_ID)
                                            }, 100);
                                        }} onMouseLeave={()=>{
                                            setTimeout(() => {
                                                sethoverId('')
                                            }, 500);
                                        }} data-tooltip-target="tooltip-discountPrice" data-tooltip-placement="right" data-tooltip-trigger="click" type="button">
                                            <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer" />
                                        </button>
                                        {
                                            hoverId=== prod.INVENTORY_ITEM_ID &&(
                                                <OfferToolTip hover={hoverId=== prod.INVENTORY_ITEM_ID} prod={prod}/>
                                            )}
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div className="lg:w-1/4 w-1/2 px-2">
                            <div className="w-full">
                                <p className="text-xs3 font-semibold text-[#808285] text-start mr-[17px]">DAP </p>
                                <p className="md:text-xs10 sm:text-lg text-base font-semibold text-[#15090E]">
                                    {PriceHandler(prod?.dap)}

                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="w-full mt-4">
                        <div className="flex sm:flex-row flex-col">
                            <button className="w-full bg-[#F5F5FA] rounded-lg text-center p-2 mt-3.5">
                                <p className="text-xs2 font-semibold text-[#808285]">Sub Total</p>
                                <div className='flex justify-center items-center pt-0.5 relative'>
                                    <p className="md:text-xs4 text-base font-semibold text-[#15090E]">{PriceHandler(Number(prod?.sub_total))}</p>
                                    <span className="ml-1" style={{minWidth:'30px'}}>
                                        <button data-tooltip-target="tooltip-discountPercentage" data-tooltip-placement="right" data-tooltip-trigger="click" type="button" onMouseEnter={()=>{
                                            setTimeout(() => {
                                                setItemPricehoverId(prod.INVENTORY_ITEM_ID)
                                            }, 100);
                                        }} onMouseLeave={()=>{
                                            setItemPricehoverId('')
                                        }}>
                                            <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer" />
                                        </button>
                                        <>
                                            {
                                                itemPricehoverId=== prod.INVENTORY_ITEM_ID &&(
                                                    <ItemPriceTooltip 
                                                        hover={itemPricehoverId=== prod.INVENTORY_ITEM_ID} 
                                                        prod={prod} 
                                                        itemPriceValue={Number(prod?.sub_total)/prod?.quantity}
                                                        onMouseEnter={()=>{
                                                            setItemPricehoverId(prod.INVENTORY_ITEM_ID)
                                                        }}
                                                        onMouseLeave={()=>{
                                                            setItemPricehoverId('')
                                                        }}
                                                    />
                                                )}
                                        </>
                                        <ItemPriceTooltip prod={prod} itemPriceValue={Number(prod?.sub_total)/prod?.quantity} />
                                    </span>
                                </div>
                            </button>
                            <button className="w-full bg-[#F5F5FA] rounded-lg text-center p-2 sm:ml-4 mt-3.5">
                                <p className="text-xs2 font-semibold text-[#808285]">Total Price</p>
                                <div className='flex justify-center items-center pt-0.5 relative'>
                                    <p className="md:text-xs4 text-base font-semibold text-[#15090E] sm:pt-0.5">{OrderData?.order?.order_type !== 'Trade EUB' ? PriceHandler(Number(prod?.total_price)) : PriceHandler((Number(prod?.sub_total) - Number(prod?.discount_applied)) + Number(prod?.dap) - ((prod?.revised_price === undefined) ? Number(prod?.proposed_total_price) : Number(prod?.revised_total_price)))}</p>
                                    <span className="ml-1" style={{minWidth:'30px'}}>
                                        <button data-tooltip-target="tooltip-discountPercentage" data-tooltip-placement="right" data-tooltip-trigger="click" type="button" onMouseEnter={()=>{
                                            setTimeout(() => {
                                                setTotalPricehoverId(prod.INVENTORY_ITEM_ID)
                                            }, 100);
                                        }} onMouseLeave={()=>{
                                            setTotalPricehoverId('')
                                        }}>
                                            <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer" />
                                        </button>
                                        <>
                                            {
                                                totalPricehoverId=== prod.INVENTORY_ITEM_ID &&(
                                                    (() => {
                                                        const subTotal = Number(prod?.sub_total) || 0;
                                                        const totalPrice = OrderData?.order?.order_type !== 'Trade EUB' ? Number(prod?.total_price) : ((Number(prod?.sub_total) - Number(prod?.discount_applied)) + Number(prod?.dap) - ((prod?.revised_price === undefined) ? Number(prod?.proposed_total_price) : Number(prod?.revised_total_price)));
                                                        const dap = Number(prod?.dap) || 0;
                                                        // Subtract DAP from totalPrice for net discount calculation
                                                        const netDiscount = subTotal > 0 ? ((subTotal - totalPrice + dap) / subTotal) * 100 : 0;
                                                        return (
                                                            <ItemPriceTooltip 
                                                                hover={totalPricehoverId=== prod.INVENTORY_ITEM_ID} 
                                                                prod={prod} 
                                                                itemPriceValue={totalPrice /prod?.quantity}
                                                                netDiscount={netDiscount}
                                                                customStyle={OrderData?.order?.order_type === 'Trade EUB' ? { bottom: '0%', marginBottom: '0px' } : undefined}
                                                                onMouseEnter={()=>{
                                                                    setTotalPricehoverId(prod.INVENTORY_ITEM_ID)
                                                                }}
                                                                onMouseLeave={()=>{
                                                                    setTotalPricehoverId('')
                                                                }}
                                                            />
                                                        );
                                                    })()
                                                )}
                                        </>
                                        {(() => {
                                            const subTotal = Number(prod?.sub_total) || 0;
                                            const totalPrice = OrderData?.order?.order_type !== 'Trade EUB' ? Number(prod?.total_price) : ((Number(prod?.sub_total) - Number(prod?.discount_applied)) + Number(prod?.dap) - ((prod?.revised_price === undefined) ? Number(prod?.proposed_total_price) : Number(prod?.revised_total_price)));
                                            const dap = Number(prod?.dap) || 0;
                                            // Subtract DAP from totalPrice for net discount calculation
                                            const netDiscount = subTotal > 0 ? ((subTotal - totalPrice + dap) / subTotal) * 100 : 0;
                                            return (
                                                <ItemPriceTooltip 
                                                    prod={prod} 
                                                    itemPriceValue={totalPrice / prod?.quantity}
                                                    netDiscount={netDiscount}
                                                    customStyle={OrderData?.order?.order_type === 'Trade EUB' ? { bottom: '100%', marginBottom: '8px' } : undefined}
                                                />
                                            );
                                        })()}
                                    </span>
                                </div>
                            </button>
                        </div>
                        {OrderData?.order?.order_type==='Trade EUB' &&
                        <div className='flex mt-2'>
                            <button className="w-full bg-[#F5F5FA] rounded-lg text-center p-2">
                                <p className="text-xs2 font-semibold text-[#808285]">Proposed Value</p>
                                <div className='flex justify-center items-center pt-0.5 relative'>
                                    <p className="md:text-xs4 text-base font-semibold text-[#15090E]">{PriceHandler((Number(prod?.sub_total) - Number(prod?.discount_applied)) - Number(prod?.proposed_total_price))}
                                        {' '}
                                        (
                                        {prod.proposed_type === '%' ? `${prod?.proposed_amount} ${prod.proposed_type}`:`${PriceHandler(prod?.proposed_amount)}`}
                                        )
                                    </p>
                                    <span className="ml-1" style={{minWidth:'30px'}}>
                                        <button data-tooltip-target="tooltip-discountPercentage" data-tooltip-placement="right" data-tooltip-trigger="click" type="button" onMouseEnter={()=>{
                                            setTimeout(() => {
                                                setProposedPricehoverId(prod.INVENTORY_ITEM_ID)
                                            }, 100);
                                        }} onMouseLeave={()=>{
                                            setProposedPricehoverId('')
                                        }}>
                                            <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer" />
                                        </button>
                                        <>
                                            {
                                                proposedPricehoverId=== prod.INVENTORY_ITEM_ID &&(
                                                    (() => {
                                                        const subTotal = Number(prod?.sub_total) || 0;
                                                        const discountApplied = Number(prod?.discount_applied) || 0;
                                                        const proposedTotalPrice = Number(prod.proposed_total_price) || 0;
                                                        // Calculate the displayed proposed value: (sub_total - discount_applied) - proposed_total_price
                                                        const displayedProposedValue = (subTotal - discountApplied) - proposedTotalPrice;
                                                        // Calculate net discount: (sub_total - displayed_proposed_value) / sub_total * 100
                                                        // DAP is not deducted here
                                                        const netDiscount = subTotal > 0 ? ((subTotal - displayedProposedValue) / subTotal) * 100 : 0;
                                                        return (
                                                            <ItemPriceTooltip 
                                                                hover={true} 
                                                                prod={prod} 
                                                                itemPriceValue={displayedProposedValue/prod?.quantity}
                                                                netDiscount={isNaN(netDiscount) ? 0 : netDiscount}
                                                                onMouseEnter={()=>{
                                                                    setProposedPricehoverId(prod.INVENTORY_ITEM_ID)
                                                                }}
                                                                onMouseLeave={()=>{
                                                                    setProposedPricehoverId('')
                                                                }}
                                                            />
                                                        );
                                                    })()
                                                )}
                                        </>
                                    </span>
                                </div>
                            </button>
                            <button className="w-full bg-[#F5F5FA] rounded-lg text-center p-2 ml-4">
                                <p className="text-xs2 font-semibold text-[#808285]">Revised Value</p>
                                <div className="flex justify-center items-center pt-0.5 relative">
                                    <p className="md:text-xs4 text-base font-semibold text-[#15090E]">{ prod.revised_price === undefined ? 'Yet to be revised'
                                        : `${PriceHandler((Number(prod?.sub_total) - Number(prod?.discount_applied)) - Number(prod?.revised_total_price))} 
                                        ${prod.revised_type === '%'
            ? `(${prod?.revised_price} ${prod.revised_type})`
            : `(${prod.revised_type} ${prod?.revised_price})`}`}
                                    </p>
                                    <span className="ml-1" style={{minWidth:'30px'}}>
                                        <button data-tooltip-target="tooltip-discountPercentage" data-tooltip-placement="right" data-tooltip-trigger="click" type="button" onMouseEnter={()=>{
                                            setTimeout(() => {
                                                setRevisedPricehoverId(prod.INVENTORY_ITEM_ID)
                                            }, 100);
                                        }} onMouseLeave={()=>{
                                            setRevisedPricehoverId('')
                                        }}>
                                            <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer" />
                                        </button>
                                        <>
                                            {
                                                revisedPricehoverId=== prod.INVENTORY_ITEM_ID &&(
                                                    (() => {
                                                        // If revised_price is undefined, show 0 for both values
                                                        if (prod.revised_price === undefined) {
                                                            return (
                                                                <ItemPriceTooltip 
                                                                    hover={true} 
                                                                    prod={prod} 
                                                                    itemPriceValue={0}
                                                                    netDiscount={0}
                                                                    onMouseEnter={()=>{
                                                                        setRevisedPricehoverId(prod.INVENTORY_ITEM_ID)
                                                                    }}
                                                                    onMouseLeave={()=>{
                                                                        setRevisedPricehoverId('')
                                                                    }}
                                                                />
                                                            );
                                                        }
                                                        const subTotal = Number(prod?.sub_total) || 0;
                                                        const discountApplied = Number(prod?.discount_applied) || 0;
                                                        const revisedTotalPrice = Number(prod.revised_total_price) || 0;
                                                        // Calculate the displayed revised value: (sub_total - discount_applied) - revised_total_price
                                                        const displayedRevisedValue = (subTotal - discountApplied) - revisedTotalPrice;
                                                        // Calculate net discount: (sub_total - displayed_revised_value) / sub_total * 100
                                                        // DAP is not deducted here
                                                        const netDiscount = subTotal > 0 ? ((subTotal - displayedRevisedValue) / subTotal) * 100 : 0;
                                                        return (
                                                            <ItemPriceTooltip 
                                                                hover={true} 
                                                                prod={prod} 
                                                                itemPriceValue={displayedRevisedValue > 0 ? displayedRevisedValue/prod?.quantity : 0}
                                                                netDiscount={isNaN(netDiscount) ? 0 : netDiscount}
                                                                onMouseEnter={()=>{
                                                                    setRevisedPricehoverId(prod.INVENTORY_ITEM_ID)
                                                                }}
                                                                onMouseLeave={()=>{
                                                                    setRevisedPricehoverId('')
                                                                }}
                                                            />
                                                        );
                                                    })()
                                                )}
                                        </>
                                    </span>
                                </div>
                            </button>
                        </div>}
                    </div>
                </div>: 
                <div className="w-full border-[#CBCBCB] py-3 border-t px-2">
                    <div className="w-full flex flex-wrap -mx-2">
                        <div className="px-2 xl:w-1/5 lg:w-1/4 md:w-1/3 w-1/2">
                            <div className="pb-5 w-full">
                                <p className="text-xs3 font-semibold text-[#808285]">List Price</p>
                                <p className="text-base font-semibold text-[#15090E]">
                                    {PriceHandler(prod?.LIST_PRICE)}
                                </p>
                            </div>
                        </div>
                        <div className="px-2 xl:w-1/5 lg:w-1/4 md:w-1/3 w-1/2">
                            <div className="pb-5 w-full">
                                <p className="text-xs3 font-semibold text-[#808285] text-start mr-[17px]">Quantity</p>
                                <p className="text-base font-semibold text-[#15090E]">
                                    {prod?.quantity}
                                    {' '}
                                    {prod?.PRIMARY_UOM_CODE}
                                </p>
                            </div>
                        </div>
                        <div className="px-2 xl:w-1/5 lg:w-1/4 md:w-1/3 w-1/2">
                            <div className="pb-5 w-full">
                                <p className="text-xs3 font-semibold text-[#808285]">Basic Value</p>
                                <p className="text-base font-semibold text-[#15090E]">
                                    {PriceHandler(prod?.sub_total)}
                                </p>
                            </div>
                        </div>
                        <div className="px-2 xl:w-1/5 lg:w-1/4 md:w-1/3 w-1/2">
                            <div className="pb-5 w-full">
                                <p className="text-xs3 font-semibold text-[#808285] text-start mr-[17px]">Discount</p>
                                <p className="text-base font-semibold text-[#15090E]">
                                    {PriceHandler((Number(prod?.discount_applied) + Number((OrderData.order.order_type === 'Trade EUB'? prod?.revised_total_price: 0))))}
                                    <span className="ml-1 relative">
                                        <button  onMouseEnter={()=>{
                                            setTimeout(() => {
                                                sethoverId(prod.INVENTORY_ITEM_ID)
                                            }, 100);
                                        }} onMouseLeave={()=>{
                                            setTimeout(() => {
                                                sethoverId('')
                                            }, 500);
                                        }} data-tooltip-target="tooltip-discountPrice" data-tooltip-placement="right" data-tooltip-trigger="click" type="button">
                                            <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer" />
                                        </button>
                                        {
                                            hoverId=== prod.INVENTORY_ITEM_ID &&(
                                                <OfferToolTip hover={hoverId=== prod.INVENTORY_ITEM_ID} prod={prod} orderData={OrderData?.order} />
                                            )}
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div className="px-2 xl:w-1/5 lg:w-1/4 md:w-1/3 w-1/2">
                            <div className="pb-5 w-full">
                                <p className="text-xs3 font-semibold text-[rgb(128,130,133)]">Sub Total</p>
                                <div className='flex items-center pt-0.5 relative'>                                
                                    <p className="text-base font-semibold text-[#15090E]">{PriceHandler(prod.line_sub_total || 0)}</p>
                                    <span className="ml-1" style={{minWidth:'30px'}}>
                                        <button data-tooltip-target="tooltip-discountPercentage" data-tooltip-placement="right" data-tooltip-trigger="click" type="button" onMouseEnter={()=>{
                                            setTimeout(() => {
                                                setSubTotalPricehoverId(prod.INVENTORY_ITEM_ID)
                                            }, 100);
                                        }} onMouseLeave={()=>{
                                            setSubTotalPricehoverId('')
                                        }}>
                                            <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer" />
                                        </button>
                                        <>
                                            {
                                                subTotalhoverId=== prod.INVENTORY_ITEM_ID &&(
                                                    <ItemPriceTooltip 
                                                        hover={subTotalhoverId=== prod.INVENTORY_ITEM_ID} 
                                                        prod={prod} 
                                                        itemPriceValue={prod.line_sub_total/prod?.quantity}
                                                        onMouseEnter={()=>{
                                                            setSubTotalPricehoverId(prod.INVENTORY_ITEM_ID)
                                                        }}
                                                        onMouseLeave={()=>{
                                                            setSubTotalPricehoverId('')
                                                        }}
                                                    />
                                                )}
                                        </>
                                        <ItemPriceTooltip prod={prod} itemPriceValue={prod.line_sub_total/prod?.quantity} />
                                    </span>
                                </div>

                            </div>
                        </div>
                        <div className="px-2 xl:w-1/5 lg:w-1/4 md:w-1/3 w-1/2">
                            <div className="pb-5 w-full">
                                <p className="text-xs3 font-semibold text-[#808285]">DAP</p>
                                <p className="text-base font-semibold text-[#15090E]">{PriceHandler(prod.dap)}</p>
                            </div>
                        </div>
                        <div className="px-2 xl:w-1/5 lg:w-1/4 md:w-1/3 w-1/2">
                            <div className="pb-5 w-full">
                                <p className="text-xs3 font-semibold text-[#808285]">Ador Cash</p>
                                <p className="text-base font-semibold text-[#15090E]">{PriceHandler(prod.ador_cash_used || 0)}</p>
                            </div>
                        </div>
                        <div className="px-2 xl:w-1/5 lg:w-1/4 md:w-1/3 w-1/2">
                            <div className="pb-5 w-full">
                                <p className="text-xs3 font-semibold text-[#808285]">Net Amount</p>
                                <div className="flex items-center pt-0.5 relative">
                                    <p className="text-base font-semibold text-[#15090E]">{PriceHandler(prod.net_value || 0)}</p>
                                    <span className="ml-1" style={{minWidth:'30px'}}>
                                        <button data-tooltip-target="tooltip-discountPercentage" data-tooltip-placement="right" data-tooltip-trigger="click" type="button" onMouseEnter={()=>{
                                            setTimeout(() => {
                                                setNetAmounthoverId(prod.INVENTORY_ITEM_ID)
                                            }, 100);
                                        }} onMouseLeave={()=>{
                                            setNetAmounthoverId('')
                                        }}>
                                            <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer" />
                                        </button>
                                        <>
                                            {
                                                netAmounthoverId=== prod.INVENTORY_ITEM_ID &&(
                                                    <ItemPriceTooltip 
                                                        hover={netAmounthoverId=== prod.INVENTORY_ITEM_ID} 
                                                        prod={prod} 
                                                        itemPriceValue={prod.net_value/prod?.quantity}
                                                        onMouseEnter={()=>{
                                                            setNetAmounthoverId(prod.INVENTORY_ITEM_ID)
                                                        }}
                                                        onMouseLeave={()=>{
                                                            setNetAmounthoverId('')
                                                        }}
                                                    />
                                                )}
                                        </>
                                        <ItemPriceTooltip prod={prod} itemPriceValue={prod.net_value/prod?.quantity} />
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="px-2 xl:w-1/5 lg:w-1/4 md:w-1/3 w-1/2">
                            <div className="pb-5 w-full">
                                <p className="text-xs3 font-semibold text-[#808285]">GST</p>
                                <p className="text-base font-semibold text-[#15090E]">{PriceHandler(prod.gst || 0)}</p>
                            </div>
                        </div>
                        <div className="px-2 xl:w-1/5 lg:w-1/4 md:w-1/3 w-1/2">
                            <div className="pb-5 w-full">
                                <p className="text-xs3 font-semibold text-[#808285]">Gross Amount</p>
                                <div className='flex items-center pt-0.5 relative'>
                                    <p className="text-base font-semibold text-[#15090E]">{PriceHandler(prod.gross_amount || 0)}</p>
                                    <span className="ml-1" style={{minWidth:'30px'}}>
                                        <button data-tooltip-target="tooltip-discountPercentage" data-tooltip-placement="right" data-tooltip-trigger="click" type="button" onMouseEnter={()=>{
                                            setTimeout(() => {
                                                setGrossAmounthoverId(prod.INVENTORY_ITEM_ID)
                                            }, 100);
                                        }} onMouseLeave={()=>{
                                            setGrossAmounthoverId('')
                                        }}>
                                            <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer" />
                                        </button>
                                        <>
                                            {
                                                grossAmounthoverId=== prod.INVENTORY_ITEM_ID &&(
                                                    <ItemPriceTooltip 
                                                        hover={grossAmounthoverId=== prod.INVENTORY_ITEM_ID} 
                                                        prod={prod} 
                                                        itemPriceValue={prod.gross_amount/prod?.quantity}
                                                        onMouseEnter={()=>{
                                                            setGrossAmounthoverId(prod.INVENTORY_ITEM_ID)
                                                        }}
                                                        onMouseLeave={()=>{
                                                            setGrossAmounthoverId('')
                                                        }}
                                                    />
                                                )}
                                        </>
                                        <ItemPriceTooltip prod={prod} itemPriceValue={prod.gross_amount/prod?.quantity} />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
            <button
                onClick={()=>{
                    setModalOpen('popup');
                }}
                type="button" data-bs-toggle="modal" data-bs-target="#exampleModalCenter2">
                <img className='absolute sm:top-6 top-[17px] right-[22px] cursor-pointer' src={ WishlistExist(wishProducts,prod.INVENTORY_ITEM_ID)?'/images/heart_active.svg':'/images/Iconawesome-heart.svg'} alt="" />
            </button>
            {Number(OrderData?.order?.status) !==0 &&<div className="border-t border-[#CBCBCB] pt-3 overflow-auto sidebar">
                <p className="font-semibold text-black text-xs9 pb-2 sm:px-4 px-0">Status</p>
                <div className="overflow-auto sidebar pt-4 px-3">
                    <OrderLevelProgress OrderDetails={OrderData.order} prod={prod} />
                    <div className="flex pt-3 justify-between">
                        <p className="text-xs font-semibold text-black min-w-[120px]">Order Placed</p>
                        <p className="text-xs font-semibold text-[#555259] min-w-[120px] sm:text-center text-sta ">Order Accepted</p>
                        <p className="text-xs font-semibold text-[#555259] min-w-[120px] sm:text-end text-start ">Product Shipped</p>
                        <p className="text-xs font-semibold text-[#555259] min-w-[120px] sm:text-end text-start ">In-transit</p>
                        <p className="text-xs font-semibold text-[#555259] min-w-[120px] sm:text-end text-center pl-12">Delivered</p>
                    </div>
                </div>
            </div>}
            {ModalOpen !=='' && <WishlistHandler
                setmodalType={setModalOpen}
                selectedItem={prod}
                handleAddToWishList={handleAddToWishList}
                wishlistLoader={loader}
                wishlistProduct={wishProducts}
                handleErrorMessage={handleErrorMessage}
                handleSuccessMessage={handleSuccessMessage}
                FromCart={true}
            />}
        </div>

        </div>
    )
}
